module.exports = __webpack_public_path__ + "static/GT-Super-Text-Bold-8cbc5698bdc77029ec3323c8fc8f41f0.woff2";